import React from "react";
import './Service.css';
import Banner from "../Banner/Banner";
import { Link } from "react-router-dom";


export function Service (){


    return(
        <div className="service">
            <div className="container">
                <div className="cards">
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-stethoscope"></i></div>
                        <h3>Diagnostics</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-syringe"></i></div>
                        <h3>Treatment</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-hospital"></i></div>
                        <h3>Surgery</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-truck-medical"></i></div>
                        <h3>Emergency</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-vial-circle-check"></i></div>
                        <h3>Vaccine</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                    <div className="card">
                        <div className="image"><i class="fa-solid fa-user-doctor"></i></div>
                        <h3>Qualified Doctors</h3>
                        <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                        <Link to="/booking"><button>Booking</button></Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
function service (){
    return(
        <>
            <Banner title="Service" smtitle="service" />
            <Service/>
        </>
    )
}
export default service;